import { render } from "./ChatWindow.vue?vue&type=template&id=00958f51&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=00958f51&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00958f51"]])

export default __exports__